// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3Kzu-","OrderButton":"BuildControls_OrderButton__15eu8","enable":"BuildControls_enable__1PhXD"};